import { Feature } from "ol";
import { Geometry } from "ol/geom";
import { FleetAlarm } from "../../models/types/voy-fleet-alarm-model.types";
import { VesselCategories } from "../../services/types/position-service.types";

export enum PositionAgeStatus {
    NORMAL = 1,
    OUTDATED = 2,
    OBSOLETE = 3
}

export interface VoyageLayersColors {
    trackColor: string;
    pastTrailMarkerColor: string;
    pastTrailLineColor: string;
    pastTrailHighlightedMarkerColor: string;
    highlightCircleColor: string;
    vesselIconAlarmColor: string;
    vesselIconColor: string;
    positionWarningMarkerWarnColor: string;
    positionWarningMarkerErrorColor: string;
    nonMaerskVesselIconColor: string;
}

export interface UpsertVesselFeatureOptions {
    imoNo: number,
    vesselName: string,
    longitude: number,
    latitude: number,
    heading: number,
    vesselLength: number | undefined,
    vesselWidth: number | undefined,
    highlight: boolean,
    positionAge: number,
    outdatedPositionText: string,
    timestamp: string,
    speed: number | null,
    source: string,
    alarms: FleetAlarm[],
    isMaersk: boolean,
    readingType: string,
    navStatus: string,
    vesselCategory: VesselCategories,
    vesselType: string;
    isSelected: boolean;
}

export enum VoyageLayersNames {
    PastTrailLayer = "Past trail layer",
    VesselsLayer = "vesselsLayer",
    WebGlVesselsLayer = "webGlVesselsLayer",
    VectorImageVesselsLayer = "vectorImageVesselsLayer",
    PlanLayer = "planLayer",
    TerminalPortLayer = "terminalPortLayer",
    VesselHighlightLayer = "vesselHighlightLayer",
    VesselFocusLayer = "VesselFocusLayer",
    PastTrailPosition = "pastTrailPosition"
}
